//components
import { Order, tableState } from './types';
import { isValid } from 'date-fns';

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
	const validDates = isValid(new Date(String(a[orderBy]))) && isValid(new Date(String(b[orderBy])));
	const _a = validDates ? new Date(String(a[orderBy])) : a[orderBy];
	const _b = validDates ? new Date(String(b[orderBy])) : b[orderBy];

	if (_b < _a) {
		return -1;
	}
	if (_b > _a) {
		return 1;
	}
	return 0;
}

export function getComparator<Key extends keyof any>(
	order: Order,
	orderBy: Key
): (a: { [key in Key]: number | string | Date }, b: { [key in Key]: number | string | Date }) => number {
	return order === 'desc'
		? (a, b) => descendingComparator(a, b, orderBy)
		: (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
	const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) {
			return order;
		}
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}

export const handleRequestSort = (tableState: tableState, setState: any, property: string) => {
	const isAsc = tableState.sortBy === property && tableState.orderBy === 'asc';
	setState({ ...tableState, orderBy: isAsc ? 'desc' : 'asc', sortBy: property });
};
